import React, { useState, useEffect } from "react";
import Preloader from "../src/components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Projects from "./components/Projects/Projects";
import Footer from "./components/Footer";
import Resume from "./components/Resume/ResumeNew";

// Projects routes
import Household from "./components/Projects/website/Household";
import RiceProductionPriority from "./components/Projects/ML/RiceProductionPriority";
import SentimentAnalysisSPayLater from "./components/Projects/NLP/SentimentAnalysisSPayLater";
import Glad2GlowSentimentAnalysis from "./components/Projects/NLP/Glad2GlowSentimentAnalysis";
import CryptoAcademySentimentAnalysis from "./components/Projects/NLP/CryptoAcademySentimentAnalysis";
import SmartCity from "./components/Projects/UI/SmartCity";
import PediCare from "./components/Projects/mobile/PediCare";
import HealthcareRoute from "./components/Projects/GIS/HealthcareRoute";
import SIMANTAU from "./components/Projects/IoT/Simantau";
import DanaSentiment from "./components/Projects/NLP/DanaSentiment";
import ExpertSystem from "./components/Projects/ML/ExpertSystem";
import AccessibilityAnalysis from "./components/Projects/GIS/AccessibilityAnalysis";
import DesaBengkel from "./components/Projects/website/DesaBengkel";
import RumahLaundry from "./components/Projects/website/RumahLaundry";
import PesonaWisata from "./components/Projects/website/PesonaWisata";
import GarudaAirlines from "./components/Projects/website/MaskapaiGaruda";
import ERPPos from "./components/Projects/website/ErpPos";
import SmartParking from "./components/Projects/IoT/SmartParking";
import SmartAttendance from "./components/Projects/mobile/SmartAttendance";
import SmartClassSchedule from "./components/Projects/mobile/SmartClassSchedule";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/project" element={<Projects />} />
          <Route path="/about" element={<About />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="*" element={<Navigate to="/" />} />
          <Route path="/projects/household" element={<Household />} />
          <Route
            path="/project/rice-production-priority"
            element={<RiceProductionPriority />}
          />
          <Route
            path="/project/sentiment-analysis-spaylater-spinjam"
            element={<SentimentAnalysisSPayLater />}
          />
          <Route
            path="/project/glad2glow-sentiment-analysis"
            element={<Glad2GlowSentimentAnalysis />}
          />{" "}
          <Route
            path="/project/crypto-academy-sentiment-analysis"
            element={<CryptoAcademySentimentAnalysis />}
          />
          <Route path="/project/smart-city" element={<SmartCity />} />
          <Route path="/project/pedicare" element={<PediCare />} />
          <Route
            path="/project/healthcare-route"
            element={<HealthcareRoute />}
          />
          <Route path="/project/simantau" element={<SIMANTAU />} />
          <Route path="/project/dana-sentiment" element={<DanaSentiment />} />
          <Route path="/project/expert-system" element={<ExpertSystem />} />
          <Route
            path="/project/accessibility-analysis"
            element={<AccessibilityAnalysis />}
          />
          <Route path="/project/desa-bengkel" element={<DesaBengkel />} />
          <Route path="/project/rumah-laundry" element={<RumahLaundry />} />
          <Route path="/project/pesona-wisata" element={<PesonaWisata />} />
          <Route path="/project/garuda-airlines" element={<GarudaAirlines />} />
          <Route path="/project/erp-pos" element={<ERPPos />} />
          <Route path="/project/smart-parking" element={<SmartParking />} />
          <Route
            path="/project/smart-attendance"
            element={<SmartAttendance />}
          />
          <Route
            path="/project/smart-class-schedule"
            element={<SmartClassSchedule />}
          />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
